import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GoliathDocumentsEnumerationTypeStore } from './../../../../enumeration-types/enumeration-type.store';
import { LocalizationModule, LocalizationService } from '@abp/ng.core';
import { DocCustomerProjectHierarchyComponent } from './../../customer-project-hierarchy/customer-project-hierarchy.component';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CustomerProjectHierarchyDto } from '@digiwall/goliath-documents/proxy';
import { DocRole } from '@digiwall/goliath-core/proxy';

@Component({
  selector: 'document-customer-project-hierarchy-global-view',
  templateUrl: './customer-project-hierarchy-global-view.component.html',
  styles: `
    .container {
      display: flex;
      flex-direction: column;
    }

    .row-item {
      display: flex;
      gap: 20px;
      align-items: center;
      margin-bottom: 10px;
    }

    .row-item > div:nth-child(1),
    .row-item > div:nth-child(2) {
      flex: 0 0 150px;
    }

    .row-item > div:nth-child(3) {
      flex: 1;
    }
  `,
  imports: [CommonModule, DocCustomerProjectHierarchyComponent, LocalizationModule],
})
export class CustomerProjectHierarchyGlobalViewComponent {
  hierarchies: CustomerProjectHierarchyDto[];

  protected enumerationTypeStore = inject(GoliathDocumentsEnumerationTypeStore);
  protected localizationService = inject(LocalizationService);
  protected modal = inject(NgbActiveModal);

  getStatus(statusId: string, role: DocRole): string {
    switch (role) {
      case DocRole.CustomerQuote:
        return this.enumerationTypeStore.quoteStatus().find(x => (x.id = statusId)).name.current;
      case DocRole.CustomerSalesPurchase:
        return this.enumerationTypeStore.purchaseOrderStatus().find(x => (x.id = statusId)).name
          .current;
      case DocRole.CustomerDeliveryNote:
        return this.enumerationTypeStore.deliveryNoteStatus().find(x => (x.id = statusId)).name
          .current;
      case DocRole.CustomerInvoice:
        return this.enumerationTypeStore.invoicedStatus().find(x => (x.id = statusId)).name.current;
      case DocRole.CustomerReturnRequest:
        return this.enumerationTypeStore.customerReturnRequestStatus().find(x => (x.id = statusId))
          .name.current;
      case DocRole.CustomerReturnNote:
        //temporary
        return this.localizationService.instant('Doc:CustomerProject:InProgress');
      case DocRole.CustomerCreditNote:
        //temporary
        return this.localizationService.instant('Doc:CustomerProject:InProgress');
    }
  }
}
